function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAWolontariatSecond = function SvgAWolontariatSecond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Warstwa 1",
    viewBox: "0 0 155.5 155.5"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M102.28 71.82v-21.8c-30.8 0-53.18 22-53.18 52.03s22.38 52.05 53.18 52.05v-21.82c-16.27 0-28.89-11.67-28.89-30.23s12.62-30.23 28.89-30.23",
    style: {
      fill: "#091f2c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.47 102.04c0-2.22-.14-4.4-.39-6.51-1.91-16.23-10.97-29.58-23.9-37.53-8.31-5.11-18.23-7.99-28.9-7.99v21.8c16.27 0 28.9 12.44 28.9 30.23s-12.63 30.23-28.9 30.23v21.82c10.67 0 20.59-2.88 28.9-7.95v6.24h23.91v-.76h.38v-49.58",
    style: {
      fill: "#98a4ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h155.5v155.5H0z",
    style: {
      fill: "none"
    }
  }));
};
export default SvgAWolontariatSecond;